import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@gonka-wallet/ui-tokens';

export interface TermsModalProps {
  readonly onAccept: () => void;
}

export function TermsModal({ onAccept }: TermsModalProps) {
  const { t } = useTranslation();
  const [accepted, setAccepted] = useState(false);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4">
      <div className="max-w-md rounded-2xl bg-surface-1 p-6">
        <h2 className="mb-4 text-xl font-semibold">{t('terms.title')}</h2>
        <ul className="mb-6 space-y-3 text-sm text-text-secondary">
          <li>{t('terms.selfCustody')}</li>
          <li>{t('terms.noRecovery')}</li>
        </ul>
        <label className="mb-4 flex items-center gap-3">
          <input
            type="checkbox"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
            className="h-5 w-5"
          />
          <span className="text-sm">{t('terms.accept')}</span>
        </label>
        <Button variant="primary" disabled={!accepted} onClick={onAccept} fullWidth>
          {t('terms.continue')}
        </Button>
      </div>
    </div>
  );
}
